import React, { useMemo } from "react";
import { AssessmentUI } from "../../../../../api/observationByAuthority";
import ReportFormTable, { ReportFormRow, TextAreaInputCell } from "../../common/ReportTableForm";
import { isCreditAreaOfFraud } from "../../../../../features/caseinfo/logic/Slice";
import { useAppSelector } from "../../../../../app/store";

interface SpecificCommentsOnFindingsFormProps {
  assessment: AssessmentUI;
  onFieldChange: <K extends keyof AssessmentUI>(key: K, value: AssessmentUI[K]) => void;
}

const SpecificCommentsOnFindingsForm: React.FC<SpecificCommentsOnFindingsFormProps> = ({
  assessment,
  onFieldChange,
}) => {

  const isCreditCase = useAppSelector(isCreditAreaOfFraud)

  const rows: ReportFormRow[] = useMemo(
    () => {
      const creditFields = !isCreditCase ? []: [{
        label: "Primary Security",
        inputCell: (
          <TextAreaInputCell
            value={assessment.primary_security_assessment ?? ""}
            onChange={(val) => onFieldChange("primary_security_assessment", val)}
            placeholder="Enter observations on Primary Security"
            disableResize
            rows={2}
            textAreaClassName="min-h-[76px]"
          />
        ),
      },
      {
        label: "Collateral Security",
        inputCell: (
          <TextAreaInputCell
            value={assessment.collateral_security_assessment ?? ""}
            onChange={(val) => onFieldChange("collateral_security_assessment", val)}
            placeholder="Enter observations on Collateral Security"
            disableResize
            rows={2}
            textAreaClassName="min-h-[76px]"
          />
        ),
      },
      {
        label: "End use of Bank's Fund",
        inputCell: (
          <TextAreaInputCell
            value={assessment.end_use_of_funds_assessment ?? ""}
            onChange={(val) => onFieldChange("end_use_of_funds_assessment", val)}
            placeholder="Enter observations on end use of funds"
            disableResize
            rows={2}
            textAreaClassName="min-h-[76px]"
          />
        ),
      },
      {
        label: "Business Operations",
        inputCell: (
          <TextAreaInputCell
            value={assessment.business_operation_assessment ?? ""}
            onChange={(val) => onFieldChange("business_operation_assessment", val)}
            placeholder="Enter observations on Business Operations"
            disableResize
            rows={2}
            textAreaClassName="min-h-[76px]"
          />
        ),
      }]
      return [
        {
          label: "KYC of Perpetrator",
          inputCell: (
            <TextAreaInputCell
              value={assessment.borrower_or_perpatrator_kyc_assessment ?? ""}
              onChange={(val) => onFieldChange("borrower_or_perpatrator_kyc_assessment", val)}
              placeholder="Enter observations on KYC of perpetrator"
              disableResize
              rows={2}
              textAreaClassName="min-h-[76px]"
            />
          ),
        },
        ...creditFields,
        {
          label: "Findings of IO",
          inputCell: (
            <TextAreaInputCell
              value={assessment.io_findings_assessment ?? ""}
              onChange={(val) => onFieldChange("io_findings_assessment", val)}
              placeholder="Enter observations on Findings of IO"
              disableResize
              rows={2}
              textAreaClassName="min-h-[76px]"
            />
          ),
        },
      ]
  },
    [assessment, onFieldChange, isCreditCase],
  );

  return (
    <div className="flex flex-col mb-7">
      <span className="font-sans font-semibold text-sm leading-5 tracking-[0%] text-[#737373] my-1.5">
        2. Specific Comments on Findings
      </span>
      <ReportFormTable rows={rows} />
    </div>
  );
};

export default SpecificCommentsOnFindingsForm;
